module.exports = __webpack_public_path__ + "static/media/IoB.1d3ceaba.svg";